import endOfWeek from 'date-fns/esm/endOfWeek';
import startOfWeek from 'date-fns/esm/startOfWeek';
import { getFiscalYear } from '../../utils/fiscalYear';
import { ProspectStatus } from '../lookups';
import { FilterActionKeys as keys } from './filtersActionKeys';
import { FilterActionTypes } from './filtersActionTypes';
import * as i from './filtersInterfaces';

export interface IFiltersState {
  //[index: string]: any;
  coOp: i.ICoOpFilters;
  financePrograms: { fiscalYear: string };
  financePreseason: { fiscalYear: string };
  financeCashDiscounts: { fiscalYear: string };
  salesCalls: i.ISalesCallFilters;
  salesCompliance: i.ISalesComplianceFilters;
  salesDashboard: i.ISalesDashboardFilters;
  salesDealers: i.ISalesDealersFilters;
  salesProspects: i.ISalesProspectsFilters;
  salesRegionSettings: i.ISalesRegionSettingsFilters;
  salesShipments: i.ISalesShipmentFilters;
}

const currentFiscal = getFiscalYear();

const initState: IFiltersState = {
  coOp: {
    financeFiscal: currentFiscal,
    marketingFiscal: currentFiscal,
    salessFiscal: currentFiscal
  },
  // change fiscal year back to currentFiscal
  financeCashDiscounts: { fiscalYear: currentFiscal },
  financePreseason: { fiscalYear: currentFiscal },
  financePrograms: { fiscalYear: currentFiscal },
  salesCalls: {
    brands: [],
    callMethods: [],
    callTypes: [],
    regions: [],
    salesDistricts: [],
    searchTerm: '',
    sid: '',
    sortBy: 'date'
  },
  salesCompliance: { fiscalYear: currentFiscal, regions: [], salesDistricts: [], searchTerm: '', sid: '' },
  salesDashboard: { companies: [], regions: [], salesDistricts: [], searchTerm: '' },
  salesDealers: { regions: [], salesDistricts: [], searchTerm: '' },
  salesProspects: {
    businessTypes: [],
    lifeCycleSteps: [],
    prospectStatusId: ProspectStatus.Favorite,
    regions: [],
    salesDistricts: [],
    searchTerm: '',
    sortBy: 'name asc',
    starRating: []
  },
  salesRegionSettings: { fiscalYear: currentFiscal },
  salesShipments: {
    dateRange: { end: endOfWeek(new Date()).getTime(), start: startOfWeek(new Date()).getTime() },
    loadStates: [],
    regions: [],
    salesDistricts: [],
    searchTerm: ''
  }
};

export function filtersReducer(state: IFiltersState = initState, action: FilterActionTypes): IFiltersState {
  switch (action.type) {
    case keys.SET_FILTERS:
      return {
        ...state,
        [action.payload.filterType]: action.payload.filters
      };
    case keys.SET_FILTERS_PARTIAL:
      return {
        ...state,
        [action.payload.filterType]: {
          ...state[action.payload.filterType],
          ...action.payload.filters
        }
      };
    default:
      return state;
  }
}
